import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store.type';
import {DEFAULT_LANG} from '../../../globalVariables/locals';

export function useETicketDir() {
    const lang = useSelector((state: RootState) => state.eTicket.data?.order?.lang ?? state.eTicket.data?.lang) ?? DEFAULT_LANG;
    const isHe = lang === 'he';

    return {lang, isHe, dir: isHe ? 'rtl' : 'ltr', i18nLang: isHe ? 'he' : 'en'} as const;
}
